import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { INVOCATION__base } from '@shared/dto/generation/graph_invoke/_invocations/_base/INVOCATION__base';

interface PROPS {
  node: INVOCATION__base;
}

export function G_LIST_ITEM__node_neighbours({ node }: PROPS) {
  /*
   * EVENTS
   */

  function onClick() {
    UTILS__graph_ui.node__select(node.meta.node_id);
  }

  /*
   * HTML
   */

  return (
    // todo: use UI_PRIMITIVE__button
    <UI_PRIMITIVE__button
      {...{ onClick }}
      draggable
      className={`w-full h-6 px-2  
        text-xs text-left
        text-component-item-foreground
        bg-component hover:bg-component-item
        rounded border border-component-border transition-colors `}
    >
      <span className="w-full truncate">{node.type}</span>
    </UI_PRIMITIVE__button>
  );
}
